import React, { useEffect, useMemo, useRef } from 'react';
import { Button, Form, Modal } from 'antd';
import { FieldType } from '@/pages/documentCompile/type';
import { useShallow } from 'zustand/react/shallow';
import useStore from '@/pages/documentCompile/store/useStore';
import { renderFormItem } from '@/pages/documentCompile/dict/help';
import { isNotUndefined } from '@/utils/tools';
import useMethods from '@/pages/documentCompile/onlyofficeFieldSetting/hooks/usemethods';

interface FieldInfoModalProps {
  visible: boolean;
  onCancel: () => void;
  fieldInfo: any;
}

const FieldInfoModal: React.FC<FieldInfoModalProps> = ({
  visible,
  onCancel,
  fieldInfo,
}) => {
  const setStoreState = useStore.setState
  const { handleFormValue, doReplaceFieldValue } = useMethods();
  const [form] = Form.useForm()
  const formDataRef = useRef<any>({})
  const { settingDomainFormData, settingProjectFormData } = useStore(
    useShallow((s) => ({
      settingDomainFormData: s.settingDomainFormData,
      settingProjectFormData: s.settingProjectFormData,
    }))
  );

  const allFormData = useMemo(() => {
    return {
      ...settingDomainFormData,
      ...settingProjectFormData
    }
  }, [settingDomainFormData, settingProjectFormData])

  console.log("fieldInfo", fieldInfo);

  const handleOk = async () => {
    const values = await form.validateFields()
    const latestSettingDomainFormData = useStore.getState().settingDomainFormData
    // console.log("values", values)
    setStoreState({
      settingDomainFormData: {
        ...latestSettingDomainFormData,
        ...formDataRef.current
      },
    });
    // 同步更新文档中的 tag 值
    doReplaceFieldValue()
    onCancel?.()
  }

  const handleFormValuesChange = (changedFields: any, allFields: any) => {
    const settingDomainFormData = useStore.getState().settingDomainFormData
    formDataRef.current = {
      ...formDataRef.current,
      ...allFields
    }
    form.setFieldsValue(formDataRef.current)
    console.log("handleFormValuesChange", changedFields, allFields)
    // setStoreState({
    //     settingDomainFormData: allFields,
    // });
  };
  
  useEffect(() => {
    if (!visible) {
      form.resetFields();
      return;
    }
    const fieldValue = allFormData[fieldInfo.fieldTag]
    console.log("fieldValue", { allFormData, fieldInfo, fieldValue })
    if (isNotUndefined(fieldValue)) {
      const processedFieldValue = handleFormValue(fieldValue, fieldInfo.fieldTag)
      form.setFieldsValue({
        [fieldInfo.fieldTag]: processedFieldValue
      })
    }
  }, [allFormData, fieldInfo.fieldTag, visible, form])


  return (
    <Modal
      title="编辑字段域值"
      open={visible}
      onCancel={onCancel}
      // footer={null}
      footer={
        // 确定和取消
        <div>
          <Button type='primary' onClick={handleOk}>确定</Button>
          <Button onClick={onCancel}>取消</Button>
        </div>
      }
      width={600}
    >

      <div>
        <Form onValuesChange={handleFormValuesChange} layout='vertical' form={form}>
          <Form.Item
            name={fieldInfo.fieldTag}
            label={fieldInfo?.name || fieldInfo?.title || fieldInfo?.fieldName}
          // rules={fieldInfo?.required ? [{ required: true, message: `请输入${fieldInfo?.name || fieldInfo?.title || fieldInfo?.fieldName}` }] : []}
          >
            {renderFormItem(fieldInfo)}
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default FieldInfoModal; 